import React from "react";
import BaseMemoryGame from "../../games/Memory/BaseMemoryGame";

const generatePhotoItems = (photos) => {
  // Each photo needs to appear twice for matching
  return photos.map((photo, index) => ({
    id: index + 1,
    image: photo,
    isImagePath: true, // This tells BaseMemoryGame to treat content as an image path
  }));
};

const BrandMemoryGame = ({
  photos,
  title = "Photo Memory",
  subtitle = "Match the identical photos",
  logoPath,
  publicationId,
  hideTitle = false,
  showDatePicker = false, // Default to false for brand preview
}) => {
  // Validate photos input
  if (!photos || !Array.isArray(photos) || photos.length === 0) {
    console.error("BrandMemoryGame requires an array of photo URLs");
    return null;
  }

  // Generate items for the memory game
  const items = generatePhotoItems(photos);

  return (
    <BaseMemoryGame
      customItems={items}
      title={title}
      subtitle={subtitle}
      logoPath={logoPath}
      publicationId={publicationId}
      hideTitle={hideTitle}
      showDatePicker={showDatePicker}
      // Override the card generation to only use photos
      customCardType="photo"
    />
  );
};

export default BrandMemoryGame;
